import React, { useEffect, useRef, useState } from 'react';
import './MoreProducts.css'
import FullScreenProject from '../../components/FullScreenProject/FullScreenProject';
import ScrollNav from '../../components/ScrollNavigation/ScrollNavigation.jsx';
import bdesignheaderimage from '../../assets/images/bdesign.png'
import bdesignlogoimage from '../../assets/logos/BDesign1.png'
import hbytalalogoimage from '../../assets/logos/talawhitelogo.png'
import galaxytala from '../../assets/images/galaxytala3.png';
import profitpulselogoimage from '../../assets/logos/profit-pulse1.png'
import profitpulseheaderimage from '../../assets/images/profitpulse.png'
import zboonlogoimage from '../../assets/logos/zboon1.png';
import zboonheaderimage from '../../assets/images/zboon.png'
import ivisaheaderimage from '../../assets/images/iv2.png'
import ivisalogoimage from '../../assets/logos/ivisalogo.png'
import '../../components/FullScreenProject/FullScreenProject.css';
import NavBar2 from '../../components/NavBar2/NavBar2.jsx';

const MoreProducts = () => {
  const projectsRef = useRef([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = projectsRef.current.indexOf(entry.target);
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            setActiveIndex(index);
          } else {
            entry.target.classList.remove('active');
          }
        });
      },
      { threshold: 0.6 }
    );

    projectsRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      projectsRef.current.forEach((el) => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  const scrollToSection = (index) => {
    const element = projectsRef.current[index];
    if (!element) return;

    element.scrollIntoView({ behavior: 'smooth' });

    const startY = window.scrollY;
    const targetY = element.offsetTop;
    const distance = targetY - startY;
    const duration = 2000;
    const startTime = performance.now();

    const easeInOutQuad = (t) =>
      t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

    const step = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeInOutQuad(progress);
      const newY = startY + distance * eased;

      window.scrollTo(0, newY);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };


  return (
    <>
      <NavBar2 />
      <div className="full-screen-projects-wrapper">
        <FullScreenProject
          ref={(el) => (projectsRef.current[0] = el)}
          backgroundColor="#000000"
          backgroundImage={galaxytala}
          logo={hbytalalogoimage}
          projectName="Shopify Accounting System "
          header="Ultimate Shopify Powerhouse"
          subheader="Unlock Real-Time Insights & Total Control of Your Shopify Finances"
          learnMoreUrl="/shopify-accounting-system"
        />

        <FullScreenProject
          ref={(el) => (projectsRef.current[1] = el)}
          backgroundColor="#000000"
          backgroundImage={ivisaheaderimage}
          logo={ivisalogoimage}
          projectName="iVisa Service"
          header="Streamline Visa Processing"
          subheader="Manage applications, track progress, and automate document verification in one powerful platform."
          learnMoreUrl="/i-visa-service"
        />

        <FullScreenProject
          ref={(el) => (projectsRef.current[2] = el)}
          backgroundColor="#000000"
          backgroundImage={bdesignheaderimage}
          logo={bdesignlogoimage}
          projectName="BDesign"
          header="Digital Receipts Solution"
          subheader="Transforming paper receipts into digital experiences for better customer engagement and sustainability."
        />
        <FullScreenProject
          ref={(el) => (projectsRef.current[3] = el)}
          backgroundColor="#000000"
          backgroundImage={profitpulseheaderimage}
          logo={profitpulselogoimage}
          projectName="Profit Pulse"
          header="Run Your Business Smarter with Mobile POS"
          subheader="Manage inventory, generate invoices, and track reports — all from your phone, wherever you are."
        />

        {/* <FullScreenProject
          ref={(el) => (projectsRef.current[4] = el)}
          backgroundColor="#000000"
          backgroundImage={zboonheaderimage}
          logo={zboonlogoimage}
          projectName="Zboon"
          header="Reward Loyalty, Boost Sales"
          subheader="Create exclusive deals and reward customers with points for every QR-scanned purchase — all through one seamless app."
        /> */}

      </div>

      <ScrollNav
        sections={projectsRef.current}
        activeIndex={activeIndex}
        onDotClick={scrollToSection}
      />

    </>
  );
};

export default MoreProducts;
